import { render } from "./App.vue?vue&type=template&id=1e01912f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1e01912f&lang=css"
script.render = render

export default script